import Header from 'components/layout/Header'
import Sidebar from 'components/layout/Sidebar'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { getCategoryData, getCompanyData, getProductData, getProductDataRaw } from 'store/data/dataSlice'
import useAuth from 'utils/hooks/useAuth'

export default function AppLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [isInitialized, setIsInitialized] = useState(false)
    const navigate = useNavigate()
    const { authenticated } = useAuth()
    const location = useLocation()
    const dispatch = useDispatch()
    
    // Check if persistence has loaded (to avoid API calls with null auth)
    const persistRehydrated = useSelector(state => state._persist?.rehydrated !== false)

    useEffect(() => {
        if (persistRehydrated && !authenticated) {
            navigate('/login')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, persistRehydrated, authenticated])

    useEffect(() => {
        // Only make API calls after persistence is rehydrated and user is authenticated
        if (persistRehydrated && authenticated && !isInitialized) {
            dispatch(getCompanyData())
            dispatch(getCategoryData())
            dispatch(getProductData())
            dispatch(getProductDataRaw())
            setIsInitialized(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, authenticated, persistRehydrated, isInitialized])

    // Show loading while persistence is rehydrating
    if (!persistRehydrated) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="text-lg">Loading...</div>
            </div>
        )
    }

    return (
        <div className="dark:bg-boxdark2 dark:text-bodydark">
            <div className="flex h-screen overflow-hidden">
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <main>
                        <div className="p-4 mx-auto max-w-screen-2xl md:p-5 2xl:p-8">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    )
}
